import sideBar from './sideBar'
import dashboard from './dashboard'
import {monitoramento} from './vns'
import ordemResultado from './ordemResultado'
import components from './components'
import {vns} from './vns'
import states from './states'
import manufacturer from './manufacturer'
import protocol from './protocol'
import fileformat from './fileformat'
import integration from './integration'
import credential from './credential'
import tipo from './tipo'
import trigger from './trigger'
import attribute from './attribute'
import functions from './functions'
import dexpara from './dexpara'
import tuevs from './tuevs'
import loinc from './loinc'
import protocolsettings from './protocolsettings'
import integrationHelper from './integrationHelper'
import rnds from './rnds'
import auto_atendimento from './auto_atendimento'
import condition_result_range from './condition_result_range'
import container_support from './container_support'
import core_sectors from './core_sectors'
import core_care_units from './core_care_units'
import core_companies from './core_companies'
import home from './home'
import result_conversion from './result_conversion'
import result_range from './result_range'
import interopera from './interopera'
import file_content from './file_content'
import queue from './queue'
import reportTrash from './reportTrash'
import reportControl from './reportControl'
import logs from './logs'
import reportEditable from './reportEditable'
import review_observation from './review_observation'


export default {
  sideBar,
  components,
  dashboard,
  monitoramento,
  ordemResultado,
  vns,
  states,
  manufacturer,
  protocol,
  fileformat,
  integration,
  integrationHelper,
  credential,
  tipo,
  trigger,
  attribute,
  functions,
  dexpara,
  tuevs,
  loinc,
  protocolsettings,
  rnds,
  auto_atendimento,
  condition_result_range,
  container_support,
  core_sectors,
  core_care_units,
  core_companies,
  home,
  result_conversion,
  result_range,
  interopera,
  file_content,
  queue,
  reportTrash,
  reportControl,
  logs,
  reportEditable,
  review_observation
}
